module.exports = __webpack_public_path__ + "static/img/sh_settled in_banner.a136eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/sh_settled in_banner.png
// module id = M3Nl
// module chunks = 1